export default "__VITE_ASSET__CWXnZ9qK__"